import { Location } from '@angular/common';
import { Component, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';
import { NextConfig } from '../../../../../../app-config';
import { UserService } from '../../../../../../data/service/user.service';
import { NavigationItem } from '../../navigation';

@Component({
  selector    : 'app-nav-group',
  templateUrl : './nav-group.component.html',
  styleUrls   : ['./nav-group.component.scss']
})
export class NavGroupComponent implements OnInit, OnDestroy
{
  @Input() item                 : NavigationItem            = {} as NavigationItem;
  @Input() layout1              : boolean                   = false;
  @Input() activeId             : any;

  public rol                    : string | null             = null;
  public titleRol               : string                    = "";
  public Entorno                : string                    = environment.variableEntorno != 'Prod' ? environment.variableEntorno : '';
  public version                : string                    = environment.version;
  public nextConfig             : any;

  private userInfoSubscription  : Subscription | undefined  = undefined;

  constructor(
    private zone        : NgZone,
    private location    : Location,
    private userService : UserService
  )
  {
    this.nextConfig           = NextConfig.config;
    this.userInfoSubscription = this.userService.userInfo$.subscribe(
      info =>
      {
        this.rol = info.rol;
        if( this.rol == "A" ) this.titleRol = "Administrador";
        if( this.rol == "C" ) this.titleRol = "Coordinador";
        if( this.rol == "T" ) this.titleRol = "Técnico";
        if( this.rol == "E" ) this.titleRol = "Usuario";
        this.userInfoSubscription?.unsubscribe();
      }
    );
  }

  ngOnInit()    : void
  {
    let current_url : any = this.location.path();
    
    if (this.location['_baseHref'] ) current_url = this.location['_baseHref'] + this.location.path();

    const link  : string          = "a.nav-link[ href='" + current_url + "' ]";
    const ele   : Element | null  = document.querySelector(link);

    if (ele !== null && ele !== undefined)
    {
      const parent      : HTMLElement | null              = ele.parentElement;
      const up_parent   : HTMLElement | null              = parent?.parentElement?.parentElement ?? null;
      const last_parent : HTMLElement | null | undefined  = up_parent?.parentElement;

            if (parent      ?.classList.contains('pcoded-hasmenu'))
      {
        if (this.nextConfig['layout'] === 'vertical') parent.classList      .add('pcoded-trigger');

        parent.classList.add('active');
      }
      else  if (up_parent   ?.classList.contains('pcoded-hasmenu'))
      {
        if (this.nextConfig['layout'] === 'vertical') up_parent.classList   .add('pcoded-trigger');

        up_parent.classList.add('active');
      }
      else  if (last_parent ?.classList.contains('pcoded-hasmenu'))
      {
        if (this.nextConfig['layout'] === 'vertical') last_parent.classList .add('pcoded-trigger');

        last_parent.classList.add('active');
      }
    }
  }

  ngOnDestroy() : void { this.userInfoSubscription?.unsubscribe(); }
}
